<template>
  <div>
    <CCard>
      <CCardHeader>
        <strong>User Profile</strong>
      </CCardHeader>
      <CCardBody>
        <!-- <CAlert
          color="warning"
          closeButton
          :show.sync="alert"
        >
          Your account is pending verification by administrator.
        </CAlert> -->
        <CForm>
          <CInput
            label="Firstname"
            :placeholder="user.firstname"
            horizontal
            disabled
          />
          <CInput
            label="Lastname"
            :placeholder="user.lastname"
            horizontal
            disabled
          />
          <CInput
            label="E-mail"
            :placeholder="user.email"
            horizontal
            disabled
          />
          <CInput
            label="Administrator Role"
            :placeholder="user.isAdministrator.toString()"
            horizontal
            disabled
          />
          <CInput
            label="Suspension"
            :placeholder="user.isSuspended.toString()"
            horizontal
            disabled
          />
          <!-- <CInput
            label="Groups"
            :placeholder="user.groups"
            horizontal
            disabled
          />
          <CInput
            label="Roles"
            :placeholder="user.roles"
            horizontal
            disabled
          /> -->
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  name: 'UserProfile',
  mounted() {
    
  },
  data () {
    return {
      // alert: false,
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.isAuthenticated
    },
    user () {
      return this.$store.state.user
    },
    isSuspended () {
      return this.$store.state.user.isSuspended
    },
    isAdministrator () {
      return this.$store.state.user.isAdministrator
    },
  },
  mounted() {
    this.alert = this.$store.state.user.isSuspended
  },
  watch: {
    // isSuspended(newValue, oldValue) {
    //   console.log('isSuspended change')
    //   this.alert = newValue
    // },
    isAdministrator(newValue, oldValue) {
      console.log('isAdministrator change')
    },
  },
  methods: {
  }
}
</script>
